import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useMeta } from "@/lib/site";
import { Overline, Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQPage() {
  useMeta("FAQ", "Frequently asked questions about Bonheur Eternal fragrances, ordering, delivery and returns.");
  const { data: faqs = [] } = useQuery({ queryKey: ["faq"], queryFn: async () => (await api.get("/faq")).data });

  return (
    <div className="pt-32 md:pt-44 pb-32 px-5 md:px-8 max-w-3xl mx-auto">
      <Reveal>
        <Overline>Customer Care</Overline>
        <h1 className="font-display text-4xl md:text-5xl text-[#2B2118] mt-4 tracking-tight">Frequently asked</h1>
      </Reveal>
      <Reveal delay={0.1} className="mt-16">
        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border border-[#2B2118]/[0.07] px-6 data-[state=open]:border-[#8F6B3A]/30">
              <AccordionTrigger data-testid={`faq-question-${f.id}`} className="text-left font-display text-lg text-[#2B2118] hover:no-underline hover:text-[#8F6B3A] py-6">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#5A4C3C] leading-loose pb-6">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  );
}
